import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async"; // NEU
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>   {/* NEU: umschließt die gesamte App */}
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
